import { Box, Button, Checkbox, FormControlLabel, Stack, TextField, Tooltip, Typography, Autocomplete } from "@mui/material";
import React, { useState, useEffect } from "react";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { DataGrid } from '@mui/x-data-grid'
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";

const SubdivisionMaster = () => {
    const [formState, setFormState] = useState({
        subdivisionCode: "",
        subdivisionName: "",
        disease: null
    });
    const [isActive, setIsActive] = useState(true);
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    });
    const [SubdivisionData, setSubdivisionData] = useState([]);
    const [DiseaseList, setDiseaseList] = useState([]);
    const [EditID, setEditID] = useState(null);
    const [isDelete, setisDelete] = useState(false);
    const [deletedID, setdeletedID] = useState(null);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);

    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Subdivision Master", "SubTab")?.editAccess

    useEffect(() => {
        getSubdivisionMaster();
        getDiseaseMasterList();
    }, []);

    const getSubdivisionMaster = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.AYURVEDA_SUBDIVISION_MASTER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setSubdivisionData(response?.data?.data || [])
                    }
                    setisloader(false)
                }).catch(e => {
                    setisloader(false)
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getDiseaseMasterList = () => {
        try {
            RestAPIService.getAll(Serviceurls.AYURVEDA_DISEASE_MASTER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setDiseaseList(response?.data?.data || [])
                    }
                }).catch(e => errorMessage(e?.response?.data?.message || e.message))
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const AddSubdivisionMaster = () => {
        try {
            if (!formState?.subdivisionName) {
                return errorMessage('Please Enter Subdivision Name');
            }
            if (!formState?.disease) {
                return errorMessage('Please Select Disease');
            }
            let data = {
                subdivision_name: formState?.subdivisionName,
                disease: formState?.disease?.id,   // store id
                is_active: isActive,
            }
            setisloader(true)
            let apiCall;
            if (EditID) {
                apiCall = RestAPIService.update(EditID, data, Serviceurls.AYURVEDA_SUBDIVISION_MASTER);
            } else {
                apiCall = RestAPIService.create(data, Serviceurls.AYURVEDA_SUBDIVISION_MASTER);
            }
            apiCall
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setFormState({
                            subdivisionCode: "",
                            subdivisionName: "",
                            disease: null
                        });
                        setIsActive(true)
                        setEditID(null)
                        getSubdivisionMaster()
                    }
                    setisloader(false)
                }).catch(e => {
                    setisloader(false)
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const deleteSubdivisionMaster = () => {
        try {
            let ID = deletedID ? [deletedID] : (delIDs || [])
            RestAPIService.delete(Serviceurls.AYURVEDA_SUBDIVISION_MASTER + `?ids=${ID}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getSubdivisionMaster()
                        setdelIDs([]);
                        setCheckBoxList([]);
                        setdeletedID(null);
                        setisDelete(false)
                    }
                }).catch(e => {
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: msg,
        })
    }

    const successMessage = (msg) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: msg,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const tableView = () => {
        const grpDelete = () => setisDelete(true)

        const gridToolBar = () => (
            <Box>
                <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
            </Box>
        )

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = SubdivisionData.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        SubdivisionData?.forEach((element, index) => element.sno = index + 1)

        const columns = [
            {
                field: 'sno', headerName: 'S.No', flex: 0.05, sortable: false,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params.row.sno}</Typography>)
            },
            {
                field: 'subdivision_code', headerName: 'Subdivision Code', flex: 0.2,
                renderCell: (params) => (<Box>{params?.row?.subdivision_code || '-'}</Box>)
            },
            {
                field: 'subdivision_name', headerName: 'Subdivision Name', flex: 0.4,
                renderCell: (params) => (params.row.subdivision_name ? params.row.subdivision_name?.length > 32 ?
                    <Tooltip placement="top" title={params.row.subdivision_name}><Typography fontSize={'0.9vw'}>{params.row.subdivision_name?.slice(0, 30) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.subdivision_name}</Typography> : '-')
            },
            {
                field: 'disease_name', headerName: 'Disease Name', flex: 0.4,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params.row.disease_name || '-'}</Typography>)
            },
            {
                field: 'is_active', headerName: 'Status', flex: 0.1,
                renderCell: (params) => (<Box>{params?.row?.is_active ? "Active" : "Inactive"}</Box>)
            },
            ...(commonDisable ? [{
                field: 'action', headerName: 'Action', flex: 0.1, headerAlign: "center", align: "center",
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <CommonEditButton size="1.5vw" onClick={() => {
                            setFormState({
                                subdivisionCode: params.row.subdivision_code || '',
                                subdivisionName: params.row.subdivision_name || '',
                                disease: DiseaseList.find(d => d.id === params.row.disease) || null
                            });
                            setEditID(params.row.id);
                            setIsActive(params.row.is_active || false);
                        }} />
                    </Stack>)
            }] : [])
        ]

        return (
            <Box sx={{ height: '64vh' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={SubdivisionData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    pageSizeOptions={[10, 20, 30]}
                    pagination
                    paginationMode="client"
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    onPaginationModelChange={(model) => {
                        setpage(model.page)
                        setpageSize(model.pageSize)
                    }}
                    headerHeight={40}
                    density='compact'
                    disableRowSelectionOnClick
                    loading={isloader}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                />
            </Box>
        )
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box sx={{ height: '13vh', width: '93vw', backgroundColor: "white", padding: "0.5vw" }}>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <TextField
                        size="small"
                        name="subdivisionCode"
                        value={formState?.subdivisionCode}
                        disabled
                        sx={{ width: "15vw", marginRight: "1vw" }}
                        label="Subdivision Code"
                        variant="outlined"
                    />
                    <TextField
                        size="small"
                        name="subdivisionName"
                        inputProps={{maxlength: 100}}
                        value={formState?.subdivisionName}
                        sx={{ width: "20vw", marginRight: "1vw" }}
                        label="Subdivision Name *"
                        variant="outlined"
                        onChange={(e) => setFormState({ ...formState, subdivisionName: e.target.value })}
                    />
                    <Autocomplete
                        size="small"
                        options={DiseaseList || []}
                        getOptionLabel={(option) => option?.disease_name || ""}
                        value={formState?.disease}
                        onChange={(event, newValue) => {
                            setFormState({ ...formState, disease: newValue })
                        }}
                        sx={{ width: "20vw", marginRight: "1vw" }}
                        renderInput={(params) => <TextField {...params} label="Disease *" />}
                    />
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "0.5vw" }}>
                    <Box>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} disabled={!EditID} size="small" />} label="Active" />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                        <Button size="small" variant="outlined" sx={{ textTransform: 'capitalize', width: '7vw', marginRight: "0.5vw" }}
                            onClick={() => {
                                setFormState({ subdivisionCode: "", subdivisionName: "", disease: null });
                                setIsActive(true)
                                setEditID(null)
                            }}>Clear</Button>
                        <Button size="small" variant="contained" sx={{ textTransform: 'capitalize', width: '7vw' }}
                            onClick={() => AddSubdivisionMaster()}>{EditID ? 'Update' : 'Save'}</Button>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ height: '64vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>

            {message.isErrorMsg &&
                <ToastMsg severity="error" msg={message.isErrorMsgText} msgPop={msgClose} />
            }
            {message.successMsg &&
                <ToastMsg severity="success" msg={message.successMsgText} msgPop={msgClose} />
            }
            {isDelete &&
                <DeletePopup
                    DeletTitle="Are you sure you want to delete this item?"
                    DeleteNotify="This action cannot be undone."
                    deleteAlertPopupClose={() => setisDelete(false)}
                    removeData={deleteSubdivisionMaster}
                    ButtonText="Yes"
                />
            }
            <Loader loaderOpen={isloader} />
        </Box>
    )
}

export default SubdivisionMaster;
